// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__3kErB","data":"styles_data__2G_Bl"};